import React from 'react';

function AddQuestionIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect width="24" height="24" fill="white" fill-opacity="0.01" />
            <path
                d="M16.002 3H4.995C4.46589 3 3.95846 3.21019 3.58432 3.58432C3.21019 3.95846 3 4.46589 3 4.995V19.005C3 20.107 3.893 21 4.995 21H19.005C19.5341 21 20.0415 20.7898 20.4157 20.4157C20.7898 20.0415 21 19.5341 21 19.005V7.998V11H19V19H5V5H13V3H16.002Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19 5V3.99C18.9974 3.72652 18.8908 3.47473 18.7036 3.28935C18.5163 3.10397 18.2635 2.99999 18 3C17.444 3 17 3.444 17 3.99V5H16C15.7348 5 15.4804 5.10536 15.2929 5.29289C15.1054 5.48043 15 5.73478 15 6C15 6.26522 15.1054 6.51957 15.2929 6.70711C15.4804 6.89464 15.7348 7 16 7H17V8.01C17.0026 8.27348 17.1092 8.52527 17.2964 8.71065C17.4837 8.89603 17.7365 9.00001 18 9C18.556 9 19 8.556 19 8.01V7H20C20.2652 7 20.5196 6.89464 20.7071 6.70711C20.8946 6.51957 21 6.26522 21 6C21 5.73478 20.8946 5.48043 20.7071 5.29289C20.5196 5.10536 20.2652 5 20 5H19Z"
                fill="white"
            />
        </svg>
    );
}

export default AddQuestionIcon;
